module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctp",
    attrs: {
      "id": "p0018-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_11",
      "id": "sn_11"
    }
  }, [_vm._v("DAY 11")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_11"
    }
  }, [_vm._v("JUST "), _c('i', [_vm._v("DON’T")]), _vm._v(" DO IT!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("When the woman saw that the fruit of the tree was good for food and pleasing to the eye, and also desirable for gaining wisdom, she took some and ate it. She also gave some to her husband, who was with her, and he ate it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 3:6")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0018-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("M")]), _vm._v("aybe you’ve noticed that we’re not especially interested in something—until someone says, “No!” We don’t especially want to do something—until someone says, “Don’t!” "), _c('i', [_vm._v("No")]), _vm._v(" and "), _c('i', [_vm._v("Don’t")]), _vm._v(" can sometimes prompt action more quickly than encouragement would!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("So, ")]), _vm._v("Eve wondered"), _c('i', [_vm._v(", what could be so bad about that fruit?")]), _vm._v(" Clearly, it was “good for food.” Could anything so “pleasing to the eye” be bad? Wouldn’t it be good to gain wisdom? And wouldn’t God want them to enjoy all he had created? In a word, "), _c('i', [_vm._v("no")]), _vm._v("—and he had clearly said so. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One wonders what Eve was thinking as she “gave some to her husband,” why Adam, “who was with her,” was silent, and why he ate. Moot points, all. Their eyes were opened. They realized they were naked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We human beings are attracted to forbidden fruit. And being like God sounds great—doing what we want, when we want, the way we want—whatever the warnings and despite the fact that God said "), _c('i', [_vm._v("no")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("DON’T LET “DON’T” TEMPT YOU TO DO!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6ecb2a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter14.vue
// module id = 102
// module chunks = 0